module.exports = __webpack_public_path__ + "img/levelvertRightPitch.2c6f2849.svg";